import SHA1 from 'js-sha1';

export function getQueryParameters() {
  const { search } = globalThis.location;

  return search
    .replace(/^\?/, '')
    .split('&')
    .reduce((acc, keyValue) => {
      const [key, value_] = keyValue.split('=');
      const value = decodeURIComponent(value_);
      return {
        ...acc,
        [key]: value,
      };
    }, {});
}

export function updateUrlQuery(data) {
  let url = globalThis.location.href;

  if (!url.includes('?')) {
    url = `${url}?`;
  }

  for (const [key, value_] of Object.entries(data)) {
    const match = url.match(`${key}=[^&]*`);
    const value = encodeURIComponent(value_);

    if (match) {
      const before = url.slice(0, match.index);
      const after = url.slice(match.index + match[0].length);

      url =
        value_ === undefined
          ? `${before}${after}`.replace(/\?&/, '?').replace(/&&/, '&').replace(/[&?]$/, '')
          : `${before}${key}=${value}${after}`;
    } else if (value_ !== undefined) {
      if (!['?', '&'].includes(url.at(-1))) {
        url = `${url}&`;
      }
      url = `${url}${key}=${value}`;
    }
  }

  const qIndex = url.indexOf('?');
  if ((qIndex && url.length > qIndex + 1) || !qIndex) {
    globalThis.history.pushState(null, '', url);
  }
}

// Function to calculate SHA-1 hash of a file
export const calculateFileHash = async (file) => {
  const content = await file.arrayBuffer();
  const hash = SHA1(content);
  return hash;
};
